import React from 'react';
import Content from './Content';

import * as styles from './TabPanel.module.scss';

export default function TabPanel({ index, tabContent, selectedTab }) {
  const isCurrentTab = selectedTab?.title === tabContent.title;

  return (
    <article
      id={`page-interlinking-panel-${index}`}
      className={!isCurrentTab ? styles.hiddenDesktop : undefined}
      role="tabpanel"
      tabIndex="0"
      aria-labelledby={`page-interlinking-tab-${index}`}
      hidden={!isCurrentTab}
    >
      <Content selectedTab={selectedTab} index={index} {...tabContent} />
    </article>
  );
}
